import { render, staticRenderFns } from "./UploadFileMetadata.vue?vue&type=template&id=16995fc7"
import script from "./UploadFileMetadata.vue?vue&type=script&lang=ts"
export * from "./UploadFileMetadata.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports